import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';
import { BaseCopySdkModel } from './base';
import { ICopiedSectionData } from '../../paste-special.interface';
import { ICopySdkModelConfig } from '../../index.interface';

export class SectionCopySdkModel extends BaseCopySdkModel {
    private sectionMode: ISectionModel;

    public constructor(model: ISectionModel) {
        super(model);
        this.sectionMode = model;
    }
    /**
     * 复制时候使用的sdk model
     */
    public getCopiedSdkModel(config: ICopySdkModelConfig = {}): ICopiedSectionData | undefined {
        if (!this.sectionMode.sdkData) return;
        return super.getCopiedSdkModel(config) as ICopiedSectionData;
    }
}
